<template>
    <el-drawer
        title="该角色开通的权限"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="40%"
        :before-close="close">
        <el-tree
            class="fx-g1 func_tree"
            :data="navs"
            show-checkbox
            node-key="id"
            :default-expand-all="true"
            :default-checked-keys="item.funcIds ? item.funcIds.split(',') : []"
            :expand-on-click-node="false"
            :props="defaultProps"
        >
        </el-tree>
    </el-drawer>
</template>

<style scoped>

</style>


<script>


    export default {
        props: [
            "item",
            "showBox",
        ],
        data() {
            return {
                show: false,
                navs: [],
                defaultProps: {
                    children: 'children',
                    label: 'name',
                    disabled: function () {
                        return true;
                    }
                },
            }

        },


        methods: {
            close() {
                this.$emit("close");
            },
            loadFuncs() {
                this.$ajaxGet("/function/institutionFunctionTree" , (data) => {
                    this.navs = data.result;
                })
            },

        },
        mounted() {
            this.show = true;
        },
        created() {
            this.loadFuncs();
        }

    }
</script>
